// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lazyProductHeroContainer":"lazyProductHeroContainer_oIFqw","fadeComplete":"fadeComplete_XIe0m","lazy":"lazy_kqdWh","show":"show_rXICm"};